namespace Nobox.Nobox {
    export interface Merge {
        From?: number;
        To?: number;
    }
}
